import React from "react";
import "./tab.css";
const AddressDetails = ({
  id,
  isDefault,
  name,
  addressTag,
  area,
  addressOne,
  addressTwo,
  country,
  state,
  city,
  pincode,
  mobileNo,
  selectedId,
  handleAddressSelect,
}) => {
  return (
    <div className="address-section">
      <div className="address-box">
        <div className="d-flex justify-content-between">
          <div className="d-flex gap-2">
            <input
              type="radio"
              checked={selectedId === id}
              onChange={() => handleAddressSelect(id)}
            />
            {isDefault && (
              <p style={{ fontSize: "13px", paddingTop: "3px" }}>Default</p>
            )}
          </div>

          <div className="address-tag">{addressTag}</div>
        </div>
        <h6 className="fw-bold pt-2">{name}</h6>

        <h6 className="mb-2 fs-10">
          {addressOne}
          {addressTwo}
        </h6>
        <h6 className="mb-2" style={{ fontSize: "14px" }}>
          {country},
        </h6>
        <div
          className="mb-2 "
          style={{ color: "black !important", fontSize: "14px" }}
        >
          {state},{city},{area}-{pincode}
        </div>
        <div className="phone">
          Mobile: <b>{mobileNo}</b>
        </div>
      </div>
    </div>
  );
};

export default AddressDetails;
